import { Flex, Link, useWalletModal } from 'vvs-uikit'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import useAuth from 'hooks/useAuth'

const useVvsGotchiWalletModal = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { login, logout } = useAuth()
  return useWalletModal(login, logout, t, account, {
    connectModalProps: {
      connectHelp: (
        <Flex justifyContent="center" py="1.5em">
          <Link
            color="darkGrey"
            href="https://docs.vvs.finance/getting-started/connecting-a-wallet"
            target="_blank"
            fontSize="13px"
            fontWeight="700"
          >
            {t('Haven’t got a crypto wallet yet?')}
          </Link>
        </Flex>
      ),
    },
  })
}

export default useVvsGotchiWalletModal
